import Icon from 'veui/components/Icon'
import { IconEdit } from 'dls-icons-vue'

Icon.register('edit', IconEdit)
